import React from 'react'
import { GoogleLogin } from '@react-oauth/google'

export const GoogleLoginButton = ({ onSuccess, onError }) => {
  
  const handleGoogleSuccess = (credentialResponse) => {
    if (onSuccess)
      onSuccess(credentialResponse)

  }

  const handleGoogleError = () => {
    console.error('Google login failed')
    
    if (onError)
      onError()

  }

  return (
    <GoogleLogin
      onSuccess={handleGoogleSuccess}
      onError={handleGoogleError}
      useOneTap
      text="signin_with"
      locale="cs"
      shape="pill"
      containerProps={{
        className: "google-login"
      }}
    />
  )
}
